module.exports = __webpack_public_path__ + "img/imgsurebt4.c72688de.png";